import _ from "lodash";

import { getContactSettingAsInt, setContactSetting, getAllContactSettings } from "./contactSettings";

export default class TablePaginationHelper {
  constructor(tableConfigItemId, defaultRowsPerPage = 10, instanceId = "default") {
    this._tableConfigItemId = tableConfigItemId;
    this._instanceId = instanceId;
    this._defaultRowsPerPage = defaultRowsPerPage;
  }

  get page() {
    return getContactSettingAsInt(`${this._tableConfigItemId}-${this._instanceId}-page`, 0);
  }

  set page(value) {
    setContactSetting(`${this._tableConfigItemId}-${this._instanceId}-page`, value, false);
  }

  get rowsPerPage() {
    return getContactSettingAsInt(this._tableConfigItemId, this._defaultRowsPerPage);
  }

  set rowsPerPage(value) {
    const allContactSettings = getAllContactSettings();
    for (let index = 0; index < allContactSettings.length; index++) {
      const contactSetting = allContactSettings[index];
      if (_.startsWith(contactSetting.configItemId, this._tableConfigItemId) && _.endsWith(contactSetting.configItemId, "-page")) {
        const newPage = Math.floor((contactSetting.setting * this.rowsPerPage) / value);
        setContactSetting(contactSetting.configItemId, newPage, false);
      }
    }

    setContactSetting(this._tableConfigItemId, value, true);
  }
}
